<template>
  <div :class="['modal-mask',(!isAgreeUseCookie&&loginChange)?'is-visible':'']">
    <div class="modal-dialog">
        <div class="t">隐私政策</div>
        <div class="body">
            <div>为向您提供更好、更个性化的服务，我们依据最新监管要求，更新本网站的《隐私政策》，特向您说明如下：</div>
            <div>1、为向您提供本网站的相关基本功能，我们会收集、使用必要信息；</div>
            <div>2、基于您的授权我们可能会浏览您的浏览记录、位置等信息，您有权拒绝授权；</div>
            <div>3、未经您的同意我们不会从第三方获取、共享或向其提供您的信息。</div>
        </div>
        <div class="btn-group">
            <div class="btn cancel-btn" @click="handleBack">暂不使用</div>
            <div class="btn ensure-btn ml16" @click="handleEnsure">同意</div>
        </div>
    </div>
  </div>
</template>

<script>

import api from '../../util/api.js'
export default {
  computed: {
    isAgreeUseCookie() {
        return this.$store.state.Index.isAgreeUseCookie;
    },
    isLoginSuccess() {
        return this.$store.state.Index.isLoginSuccess;
    },
    loginChange() {
      return this.$store.state.loginchange.loginChange
    }
  },
  methods: {
    handleEnsure() {
      this.$store.dispatch('changeCookie',{opType: 4})
    },
    handleBack() {
      api.logout()
      .then(response => {
        this.$store.dispatch("removeMember");
        localStorage.removeItem("apiKey");
        localStorage.removeItem("apiKeyDate");
        this.$store.dispatch("loginChange");
        this.noregister = false;
        this.$store.commit('changeState',{bool: false})
      this.$router.push("/login/registerorsginIn?stepId=sign");
      })
      .catch(() => {
        console.log("网络异常");
      });
    }
  }
}
</script>
<style lang="less" scoped>

.modal-mask{
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10002;
  background-color: rgba(0,0,0,.6);
  opacity: 0;
  visibility: hidden;
  transition: opacity .3s 0s ,visibility 0s .3s; //关闭时
  &.is-visible{
    opacity: 1;
    visibility: visible;
    transition: opacity .3s 0s,visibility 0s 0s; //打开时
    .modal-dialog{
      transform: translateY(0);
    }
  }
  .modal-dialog{
    position: absolute;
    top: 1rem;
    left: 50%;
    margin-left: -2.56rem;
    width: 5.12rem;
    height: 4.2rem;
    background-color: #fff;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
    transform: translateY(-1rem);
    transition: transform .3s;
    padding: 0 .32rem;
    .t{
        font-size: .18rem;
        color: #333;
        margin: .16rem 0;
        font-weight: bold;
    }
    .body{
        font-size: .16rem;
        color: #333;
        line-height: .26rem;
        height: 2.72rem;
    }
    .btn-group{
        display: flex;
        justify-content: center;
        margin-top: .3rem;
        .btn{
            width: 1.2rem;
            height: .36rem;
            line-height: .36rem;
            text-align: center;
            font-size: .16rem;
            padding: 0;
            border-radius: 0;
            cursor: pointer;
        }
        .cancel-btn{
            color: #00ABEB;
            border:1px solid #00ABEB;
        }
        .ensure-btn{
            background-color: #00ABEB;
            color: #fff;
            border: 1px solid #00ABEB;
        }
        .ml16{
            margin-left: .16rem;
        }
    }
  }
}

</style>




// WEBPACK FOOTER //
// src/components/common/PolicyModal.vue